import React, { FC } from 'react';
import { IconInfoRound } from '@ch/common/components/icon';
import { QuizTooltipWrap, QuizTooltipStyled } from './quiz-tooltip.styled';

const QuizTooltip: FC<{ id: string; children: string; hoverElement?: any }> = ({ id, children, hoverElement }) => {
  return (
    <QuizTooltipWrap>
      {hoverElement ? (
        React.cloneElement(hoverElement, { 'data-for': id, 'data-tip': true })
      ) : (
        <IconInfoRound $size={14} $color="grayMedium" $m={[0, 0, 0, 5]} data-tip data-for={id} />
      )}
      <QuizTooltipStyled id={id} place="right" effect="solid">
        {children}
      </QuizTooltipStyled>
    </QuizTooltipWrap>
  );
};

export default QuizTooltip;
